import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShadowLayerService {
  public showShadowLayer = new BehaviorSubject(false);
}
